export default __webpack_public_path__ + "static/media/markerPoint.d082d6c1.svg";